import { Image } from 'foundations-components/transitional/components/Image';
import styled from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
const ThumbnailImageContainer = styled.div.withConfig({
  displayName: "ThumbnailImage__ThumbnailImageContainer",
  componentId: "sc-1trzyma-0"
})(["aspect-ratio:1;height:100%;"]);
const ThumbnailImage = ({
  name,
  src
}) => {
  const hasSrc = src && src.length;
  return /*#__PURE__*/_jsx(ThumbnailImageContainer, {
    children: hasSrc && /*#__PURE__*/_jsx(Image, {
      alt: name,
      shape: "circle",
      src: src
    })
  });
};
export default ThumbnailImage;